import {Table, TableBody, TableCell, TableContainer, TableRow} from "@material-ui/core";
import {coreStyle, EnhancedTableHead} from "../../../styles/config";
import DeleteButton from "../../../utils/delete";
import React from "react";
import Translate from "../../../utils/utils";

const TableList = ({moduleItems, onEditClicked, moduleName, removeItemInListing, headCells, isLoading, shouldDeleteOrCreate}) => {
    return (
        <TableContainer>
            <Table
                className={coreStyle.table}
                aria-labelledby="tableTitle"
                aria-label="enhanced table"
            >
                <EnhancedTableHead
                    rowCount={moduleItems.length}
                    headCells={headCells}
                    isLoading={isLoading}
                />
                <TableBody>
                    {moduleItems.map(moduleItem => {
                        return (
                            <TableRow
                                hover
                                tabIndex={-1}
                                key={moduleItem.id}
                            >
                                <TableCell component="th" scope="row" className="w-75">
                                    {moduleItem.name}
                                </TableCell>
                                <TableCell>
                                    <button className='button-edit-delete' onClick={() => {
                                        onEditClicked(moduleItem)
                                    }}>
                                        <Translate id={"TABLE.ACTIONS.EDIT"}/>
                                    </button>

                                    {shouldDeleteOrCreate() && <>
                                        <em className='actions-separator'>|</em>
                                        <DeleteButton
                                            module={moduleName}
                                            itemId={moduleItem.id}
                                            itemName={moduleItem.name}
                                            removeItemInListing={removeItemInListing}
                                        />
                                    </>}
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
export default TableList;
